const en = {
  // COMMON
  language: "Language",
  note: "Note:",
  date: "Date",
  time: "Time",
  price: "Price",
  month: "Month",
  nearbyTemples: "Nearby Temples",
  createTemples: "Create Temples",
  temples: "Temples",
  latestTemples: "Latest Temples",
  groupOfTemples: "Group of Temples",

  //DASHBOARD
  templeCreateDescription:
    "Creating a temple profile is simple, meaningful, and free. Let your temple’s story inspire others and become part of a growing spiritual network.",

  // NAVIGATION
  backToSearch: "Back to Search",
  backToDashboard: "Back to Dashboard",
  templeView: "Temple View",
  editTemples: "Edit Temples",
  backToTemples: "Back to Temples",

  // PROFILE
  profile: "Profile",
  personalInfo: "Personal Information",
  locationBackground: "Location & Background",
  spiritualIdentification: "Spiritual & Identification",
  editProfile: "Edit Profile",
  profilePhoto: "Profile Photo",
  backToProfile: "Back to Profile",
  saveProfile: "Save Profile",
  optional: "(Optional)",

  // TEMPLE DETAILS
  templeGallery: "Temple Gallery",
  mainDeity: "Presiding Deity",
  otherDeity: "Other Deities",

  // ADDRESS
  location: "Location",
  address: "Address",
  city: "City",
  district: "District",
  state: "State",
  pincode: "Pincode",
  geographicCoordinates: "Geographic Coordinates",
  cityTownVillage: "City / Town / Village",

  // FACILITIES
  availableFacilities: "Available Facilities & Access",
  ritualsGuidelines: "General Info",
  dressCode: "Dress Code",
  festivalEvents: "Festival & Events",
  poojaDetails: "Pooja Details",
  contactInfo: "Contact Info",
  templeTimings: "Temple Timings",
  morning: "Morning",
  afternoon: "Afternoon",
  sthalaVirutcham: "Sthala Virutcham",
  bestTime: "Best Time to Visit",
  atonementRituals: "Atonement",
  howToReach: "How to Reach",
  km: "Km",

  // OWNERSHIP
  ownershipDetails: "Managed by",
  // managedBy: "Managed by",

  //TEMPLE CONTACT
  templeEmail: "Temple Email Address",
  templeOwnershipContact: "Temple Ownership Contact Info",
  otherContactInfo: "Other Contact Info",

  // REVIEWS
  reviews: "Reviews",
  communityReviews: "Reviews from our community",
  searchReviews: "Search Reviews",
  reviewDetails: "Review Details",
  review: "Review",

  // EXPERIENCES
  userExperience: "Experiences",
  shareYourExperience: "Share Your Experience",
  communityExperiences: "Experiences from Our Community",
  searchExperiences: "Search Experiences",
  experienceDetails: "Experience Details",
  search: "Search",

  // SUGGESTIONS
  suggestUpdate: "Suggest an Update",
  helpImprove1: "Know something that we missed about",
  helpImprove2:
    "Share your suggestions to help us keep the information accurate and up-to-date.",
  suggestion: "Suggestion",

  // LINKS
  referenceLink: "Reference Link",
  otherGroupTemples: "Other Temples in This Group",

  // BUTTON LABELS
  viewAllTemples: "View All Temples",
  getDirection: "Get Direction",
  website: "Temple Website",
  writeReview: "Write a Review",
  addSuggestion: "Add Suggestion",
  next: "Next",
  previous: "Previous",
  cancel: "Cancel",
  submit: "Submit",
  updatePassword: "Update Password",
  updateNow: "Update Now",

  // INPUT LABELS
  name: "Name",
  phoneNumber: "Phone Number",

  // PASSWORD
  currentPassword: "Current Password",
  newPassword: "New Password",
  confirmNewPassword: "Confirm New Password",
  passwordNote:
    "After successfully updating your password, you’ll be automatically redirected to the login page for security reasons. Please sign in using your new password to continue.",

  // USER PROFILE INFO
  firstName: "First Name",
  lastName: "Last Name",
  fullName: "Full Name",
  dateOfBirth: "Date of Birth",
  age: "Age",
  gender: "Gender",
  email: "Email Address",
  phone: "Phone Number",
  bio: "Bio",
  religion: "Religion",
  visitFrequency: "Visit Frequency",
  maritalStatus: "Marital Status",
  aadhaarNumber: "Aadhaar Number",
  passportNumber: "Passport Number",
  occupation: "Occupation",
  bloodGroup: "Blood Group",

  // EMPTY LABELS
  noGuidelines: "No Guidelines Data Available.",
  noDressCode: "No Dress Code Data Available.",
  noAtonementRituals: "No Atonement Rituals at This Temple.",
  noTransport: "No nearby transport options available.",
  noReviews: "Be the first to share your temple experience.",
  noFestivalEvents: "No Festival or Event Data Available.",
  noPoojaData: "No Pooja Data Available.",
  noOwnershipData: "No Ownership Data Available.",
  noContactData: "No Contact Data Available.",
  noTempleImages: "No temple images available.",

  // COMMON LABELS
  shareTemple: "Share This Temple",
  copied: "Copied!",
};

export default en;
